import { Observable } from 'rxjs';

export interface INotificacoesQuery {
  quantidadeNotificacoesNaoLidas$: Observable<number>;
}

export const NOTIFICACOES_QUERY_INJECT_KEY = 'NotificacoesQuery';
